import React from 'react';
import { useSelector } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';
import InputField from 'components/FieldTypes/InputField';

import { getExchangeState } from '../rdx';

const UISelectAllCheckBoxForReturns: PosPlugin['UISelectAllCheckBoxForReturns'] = ({
  children,
}) => {
  const exchangeState = useSelector(getExchangeState);

  return (
    <>
      {exchangeState.exchangeStep >= 1 ? (
        <th className="align-middle">
          <InputField
            type="checkbox"
            disabled={true}
            value=""
            onChange={() => {}}
          />
        </th>
      ) : (
        children
      )}
    </>
  );
};

export default UISelectAllCheckBoxForReturns;
